import React from 'react';
import { Link } from 'react-router-dom';
import './HelpSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const HelpSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="help-section" id="help-section">
      <div className="container">
        <div className="help-content">
          <h2 >{t('helpSection.title')}</h2>
          <p className="help-subtitle">{t('helpSection.subtitle')}</p>
          
          <div className="help-options">
            <Link to="https://wa.me/+22224400001" className="help-card">
              <div className="help-icon">
                <FontAwesomeIcon icon={faQuestionCircle} />
              </div>
              <h3>{t('helpSection.options.helpCenter.title')}</h3>
              <p>{t('helpSection.options.helpCenter.description')}</p>
              <span className="help-link">{t('helpSection.options.helpCenter.linkText')}</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
